<template>
    <div>
    <b-row class="filterRow emptySoonWidget">
        <b-col>
            <p class="smallText"><AnimatedNumber :number="filteredWineData.length" />Positionen</p>
            <div class="spacer xs"/>
            <h2>{{$t('insights.emptySoonWidget.title')}}</h2>
        </b-col>
        <b-col id="glassModeSwitch" class="getAllContent">

            <b-form-checkbox v-model="glassMode" @change="refreshTable()" name="check-button" switch>
                {{$t('insights.emptySoonWidget.glassModeFilter')}}
            </b-form-checkbox>
            <b-button-group class="toggleButtons wineViewFilter">
                <b-button @click="refreshTable(amounts[0])" :class="amountFilter==amounts[0] ? 'active':''">&#60;{{amounts[0]}}</b-button>
                <b-button @click="refreshTable(amounts[1])" :class="amountFilter==amounts[1] ? 'active':''">&#60;{{amounts[1]}}</b-button>
                <b-button @click="refreshTable(amounts[2])" :class="amountFilter==amounts[2] ? 'active':''">&#60;{{amounts[2]}}</b-button>
            </b-button-group>  
        </b-col>
        
    </b-row>
    <div class="spacer m"></div>
    <b-row >  
        <b-col>
        <div class="chartOuterContainer">
            <div class="noResults" v-if="filteredWineData.length === 0 && loading === false">
                <svg width="82" height="154" viewBox="0 0 82 154" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero">
                        <path d="M36.996 87.614c0 19.647-.001 39.226.002 58.806 0 1.828-.802 3.164-2.25 4.259-1.422 1.074-3.041 1.667-4.68 2.194-1.082.348-2.283.306-3.389.6-1.57.417-3.169.243-4.741.417-2.037.225-4.06.024-6.089.087-1.166.036-2.34-.037-3.505-.133-.846-.07-1.686-.237-2.522-.398-1.054-.204-2.127-.362-3.144-.69-1.565-.506-3.094-1.085-4.445-2.116-1.384-1.056-2.095-2.41-2.188-4.087-.059-1.08.09-2.17.106-3.255.008-.476-.118-.954-.12-1.43-.01-4.327-.005-8.653-.005-12.979V67.778c0-2.148-.07-4.3.02-6.444.085-2.025.223-4.061.553-6.057.282-1.71.691-3.446 1.369-5.03.655-1.534 1.674-2.923 2.624-4.312 1.084-1.583 2.663-2.613 4.306-3.532.433-.242.887-.5 1.362-.596.61-.122.665-.455.664-.976-.013-7.953-.009-15.907-.009-23.86v-5.16c0-.617.004-1.233-.001-1.849-.005-.498.102-1.011-.388-1.404-.138-.112-.14-.44-.142-.67-.014-1.059-.007-2.118-.005-3.177 0-.154-.032-.33.028-.46.473-1.02.883-2.084 1.475-3.03C12.355.463 13.118 0 14.096.005c2.734.017 5.468.04 8.2-.006 2.002-.032 3.139.815 3.567 2.633.182.774.795 1.32.785 2.122-.015 1.156-.003 2.313-.007 3.47 0 .058-.028.14-.07.17-.76.52-.597 1.311-.598 2.05-.001 9.847.02 19.693-.03 29.539-.006 1.12.286 1.806 1.345 2.106 1.25.355 2.287 1.083 3.238 1.923 2.029 1.79 3.71 3.847 4.584 6.467.462 1.387.92 2.777 1.297 4.188.167.623.123 1.302.187 1.954.13 1.318.38 2.636.384 3.955.034 8.99.018 17.98.018 27.037zM72.745 151.185c1.373.134 2.697.18 3.98.435.84.167 1.767.174 2.49.759.103.083.144.242.214.366-.13.063-.256.14-.392.186-1.607.549-3.283.678-4.957.806a46.15 46.15 0 0 1-2.556.134c-2.682.056-5.365.124-8.048.129-2.057.004-4.118-.028-6.171-.146-1.138-.065-2.26-.395-3.398-.495-.646-.057-1.274-.074-1.845-.415-.198-.119-.389-.252-.583-.379.208-.191.395-.517.626-.551 1.482-.222 2.973-.393 4.463-.557 1.371-.15 2.776-.146 4.106-.463.614-.146 1.183-.825 1.601-1.39.675-.913.988-1.96.98-3.157-.043-6.642-.05-13.285.002-19.926.012-1.454-.763-2.277-1.779-3.044-1.175-.886-2.398-1.72-3.506-2.686-1.845-1.607-3.413-3.474-4.74-5.54a22.383 22.383 0 0 1-2.443-5.101c-.501-1.523-.969-3.063-1.321-4.625a18.293 18.293 0 0 1-.414-3.456c-.064-2.105-.082-4.216.005-6.32.054-1.32.33-2.632.514-3.947.127-.909.22-1.826.413-2.721.224-1.04.52-2.066.823-3.085.486-1.634.983-3.265 1.52-4.883.279-.843.662-1.651.981-2.482.184-.479.546-.615 1.01-.614 1.854.003 3.707.001 5.56.001 5.49 0 10.982.016 16.474-.018.737-.004 1.086.38 1.335.92.267.58.439 1.207.642 1.817.419 1.26.855 2.516 1.24 3.787.442 1.465.916 2.917 1.102 4.458.143 1.181.521 2.333.773 3.503.082.376.117.767.136 1.153.056 1.169.073 2.34.147 3.507.034.55.173 1.094.244 1.643.03.241.037.492.01.734-.124 1.156-.255 2.31-.4 3.464-.135 1.084-.202 2.186-.456 3.242-.404 1.68-.802 3.384-1.454 4.973-.66 1.608-1.56 3.13-2.472 4.617-1.17 1.91-2.685 3.565-4.357 5.038-1.245 1.097-2.658 2-3.96 3.034-.871.692-1.471 1.638-1.478 2.752-.039 6.545-.056 13.09.005 19.635.017 1.891.939 3.485 2.466 4.587.46.332 1.233.24 1.866.315.308.036.623.006 1.002.006z"/>
                    </g>
                </svg>
                <p><span class="emptyState">{{$t('insights.emptySoonWidget.noResults')}}</span></p>
            </div>
           <div class="noResults" v-if="filteredWineData.length === 0 && loading === true">
                <LoadingAnimation />
            </div>
            <div v-if="filteredWineData.length > 0">
                <b-table 
                    ref="emptySoonWineList"
                    :items="filteredWineData" 
                    :fields="fields"  
                >
                    <!-- A custom formatted column -->
                    <template #cell(attributes.purchasePriceAvg)="data">
                    {{data.value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}
                    </template>
                    <!-- A custom formatted column -->
                    <template #cell(attributes.sellingPrice)="data">
                    {{data.value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}
                    </template>
                       <!-- A custom formatted column -->
                    <template #cell(attributes.year)="data">
                        <span v-if="data.value === 0 || !data.value">{{ $t('general.notDefined') }}</span>
                        <span v-else>{{data.value}}</span>
                    </template>

                </b-table>
            </div>
        </div>
        </b-col>
    </b-row>
    
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import DataService from '@/services/StrapiService'
    import LoadingAnimation from '@/components/LoadingAnimation.vue'
    import AnimatedNumber from '@/components/AnimatedNumber.vue'
    import { getVenueCurrency } from '@/utils/functions'
    
    export default {
        name: 'EmptySoonWidget',
        components: {
            LoadingAnimation, AnimatedNumber
        },
        data() {
            return {
                wineData: [],
                filteredWineData: [],
                amounts: [5,10,20],
                amountFilter: 5,
                loading: true,
                glassMode: false,
            }
        },
        created () {
            this.loadData()
        },
        methods: {
            /**
             * Load VenueWines with biggest possible amount to get all at once
             */
            loadData() {
                this.loading = true
                DataService.getEmptySoonVenueWines(this.amounts[this.amounts.length -1]).then((response) => {
                    this.wineData = response['data'].data
                    this.refreshTable(this.amountFilter)
                    this.loading = false
                }).catch((err) => {
                    this.loading = false
                    console.log(err)
                })
            },
            /**
             * Filter VenueWines by selected amount and refresh table
             * @param {*} amount 
             */
            refreshTable(amount) {
                if (amount >= 0) {
                    this.amountFilter = amount
                }
                this.filteredWineData = this.wineData.filter(venueWine => venueWine.attributes.amountFloat <= this.amountFilter && venueWine.attributes.glassMode == this.glassMode)
            }
        },
        computed: {
            getCurrency() {
                return getVenueCurrency(this.getVenue)
            },
            fields() { 
              return [
                    {
                        key: 'attributes.wine.data.attributes.winery.data.attributes.title',
                        label: this.$t('general.winery')
                    },
                    {
                        key: 'attributes.title',
                        label: this.$t('general.winetitle')
                    },
                    {
                        key: 'attributes.year',
                        label: this.$t('general.vintage_short'),
                        sortable: true
                    },
                    {
                        key: 'attributes.purchasePriceAvg',
                        label: this.$t('general.ek_short') + ' '+this.getCurrency,
                        sortable: true
                    },
                    {
                        key: 'attributes.sellingPrice',
                        label: this.$t('general.vk_short') + ' '+this.getCurrency,
                        sortable: true
                    },
                    {
                        key: 'attributes.shelfNumber',
                        label: this.$t('general.shelf')
                    },
                    {
                        key: 'attributes.amountFloat',
                        label: this.$t('general.amount'),
                        sortable: true
                    },
                ]
            },
            ...mapGetters(['getUser', 'getVenue'])
        },
    }
</script>
<style scoped>
</style>